import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'

// -----------------------------------------------------------------------------
// API Calls

function fetchAttentionIndex () {
  return utils.makeApiCall({
    url: '/api/insights/attention/index/details',
    actionRequest: ActionTypes.REQUEST_ATTENTION_INDEX,
    actionReceive: ActionTypes.RECEIVE_ATTENTION_INDEX,
    actionFailure: ActionTypes.REQUEST_ATTENTION_INDEX_FAILURE,
    authenticated: true
  })
}


// -----------------------------------------------------------------------------
// User invokable actions

export function fetchAttentionIndexIfNeeded () {
  return (dispatch) => {
    // const state = (getState().homepage.byId[topicId] || {}).topShows
    // if (utils.shouldFetch(state)) {
    return dispatch(fetchAttentionIndex())
    // }
    // return Promise.resolve()
  }
}